(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ft-banquets-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var form = document.getElementById('ft-banquets-form');
    var success = document.getElementById('ft-banquets-success');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        form.style.display = 'none';
        if (success) success.style.display = 'block';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-calendar-filter"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function applyGenreFilter(genre) {
      // List view: each .ft-cal-day-row is a day with one or more shows inside
      document.querySelectorAll('.ft-cal-day-row').forEach(function(row) {
        if (genre === 'All') {
          row.style.display = '';
        } else {
          var shows = row.querySelectorAll('[data-artist-genre]');
          var hasMatch = false;
          shows.forEach(function(s) { if (s.dataset.artistGenre === genre) hasMatch = true; });
          row.style.display = hasMatch ? '' : 'none';
        }
      });
      // Grid view: each .ft-cal-grid-card is one show
      document.querySelectorAll('.ft-cal-grid-card').forEach(function(card) {
        if (genre === 'All') {
          card.style.display = '';
        } else {
          card.style.display = card.dataset.artistGenre === genre ? '' : 'none';
        }
      });
    }

    function setView(view) {
      var listView = document.getElementById('ft-calendar-list');
      var gridView = document.getElementById('ft-calendar-grid');
      if (listView) listView.style.display = view === 'list' ? '' : 'none';
      if (gridView) gridView.style.display = view === 'grid' ? '' : 'none';
      document.querySelectorAll('.ft-view-btn').forEach(function(b) {
        if (b.dataset.view === view) {
          b.style.background = 'rgba(201,164,86,0.15)';
          b.style.borderColor = '#c9a456';
          b.style.color = '#c9a456';
          b.classList.add('ft-view-btn--active');
        } else {
          b.style.background = '#1a1712';
          b.style.borderColor = '#2e2820';
          b.style.color = '#6b6055';
          b.classList.remove('ft-view-btn--active');
        }
      });
    }

    document.addEventListener('click', function(e) {
      var t = e.target && e.target.closest;
      if (!t) return;

      var genreBtn = e.target.closest('.ft-genre-filter');
      if (genreBtn && genreBtn.dataset.genre) {
        var genre = genreBtn.dataset.genre;
        document.querySelectorAll('.ft-genre-filter').forEach(function(f) {
          if (f.dataset.genre === genre) {
            f.style.background = 'linear-gradient(135deg, #9c7a32, #c9a456)';
            f.style.color = '#0e0c09';
            f.style.borderColor = 'transparent';
          } else {
            f.style.background = '#1a1712';
            f.style.color = '#a09282';
            f.style.borderColor = '#2e2820';
          }
        });
        applyGenreFilter(genre);
        return;
      }

      var viewBtn = e.target.closest('.ft-view-btn');
      if (viewBtn && viewBtn.dataset.view) {
        setView(viewBtn.dataset.view);
        return;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-contact-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var form = document.getElementById('ft-contact-form');
    var success = document.getElementById('ft-contact-success');
    var successMsg = document.getElementById('ft-contact-success-msg');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var email = form.querySelector('[name="contact[email]"]');
        var emailVal = email ? email.value : '';
        if (successMsg && emailVal) {
          successMsg.textContent = 'A member of our team will confirm your reservation at ' + emailVal + ' as soon as possible — typically within a few hours.';
        }
        form.style.display = 'none';
        if (success) success.style.display = 'block';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-event-product"]) return;
  try {
    
  (function() {
    var form = document.getElementById('ft-ep-form');
    var amountDisplay = document.getElementById('ft-ep-selected-amount');
    var variantBtns = document.querySelectorAll('.ft-ep-variant-btn');
    var loader = document.getElementById('ft-ep-loader');
    var variantInput = document.getElementById('ft-ep-variant-input');

    // Update displayed amount + hidden input when variant button is clicked
    variantBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = btn.dataset.variantId;
        var variantPrice = btn.dataset.variantPrice;

        // Update hidden input
        if (variantInput) variantInput.value = variantId;

        // Update amount display
        if (amountDisplay) amountDisplay.textContent = variantPrice;

        // Update visual selection
        variantBtns.forEach(function(b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');

        // Update URL without reload
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url);
      });
    });

    // Auto-add to cart and redirect to /cart on page load
    function autoAddToCart() {
      var id = variantInput ? variantInput.value : '';
      if (!id) return;

      // Show loader
      if (loader) {
        loader.style.display = 'flex';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
      .then(function(res) {
        if (res.ok) {
          window.location.href = '/cart';
        } else {
          // On error, hide loader and let user use the form manually
          if (loader) loader.style.display = 'none';
        }
      })
      .catch(function() {
        if (loader) loader.style.display = 'none';
      });
    }

    // Run auto-checkout on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', autoAddToCart);
    } else {
      autoAddToCart();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-events-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var filterBtns = document.querySelectorAll('.ft-events-filter-btn');
    var cards = document.querySelectorAll('.ft-event-card');
    filterBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var cat = btn.dataset.category;
        filterBtns.forEach(function(b) {
          if (b === btn) {
            b.style.background = 'linear-gradient(135deg, #9c7a32, #c9a456)';
            b.style.color = '#0e0c09';
            b.style.borderColor = 'transparent';
          } else {
            b.style.background = '#1a1712';
            b.style.color = '#a09282';
            b.style.borderColor = '#2e2820';
          }
        });
        cards.forEach(function(card) {
          if (cat === 'All' || card.dataset.category === cat) {
            card.style.display = '';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-home-faq"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.ft-faq').forEach(function(container) {
      var triggers = container.querySelectorAll('.ft-faq__trigger');
      triggers.forEach(function(btn) {
        btn.addEventListener('click', function() {
          var item = btn.closest('.ft-faq__item');
          var body = item.querySelector('.ft-faq__body');
          var icon = item.querySelector('.ft-faq__icon');
          var isOpen = btn.getAttribute('aria-expanded') === 'true';

          triggers.forEach(function(b) {
            var it = b.closest('.ft-faq__item');
            it.querySelector('.ft-faq__body').style.maxHeight = '0';
            it.querySelector('.ft-faq__icon').textContent = '+';
            it.querySelector('.ft-faq__icon').style.background = 'transparent';
            it.style.borderColor = '#2e2820';
            b.setAttribute('aria-expanded', 'false');
          });

          if (!isOpen) {
            body.style.maxHeight = body.scrollHeight + 'px';
            icon.textContent = '−';
            icon.style.background = 'rgba(201,164,86,0.1)';
            item.style.borderColor = 'rgba(201,164,86,0.4)';
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-home-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.ft-testimonials-carousel').forEach(function(carousel) {
      var slides = carousel.querySelectorAll('.ft-testimonial-slide');
      var dots = carousel.querySelectorAll('.ft-dot');
      var prevBtn = carousel.querySelector('.ft-testimonials-prev');
      var nextBtn = carousel.querySelector('.ft-testimonials-next');
      var total = slides.length;
      if (!total) return;
      var current = 0;
      var timer;

      function show(idx) {
        slides[current].style.display = 'none';
        if (dots[current]) {
          dots[current].style.background = '#2e2820';
          dots[current].style.width = '6px';
        }
        current = (idx + total) % total;
        slides[current].style.display = 'block';
        if (dots[current]) {
          dots[current].style.background = '#c9a456';
          dots[current].style.width = '24px';
        }
      }

      function startTimer() {
        timer = setInterval(function() { show(current + 1); }, 5000);
      }
      function resetTimer() {
        clearInterval(timer);
        startTimer();
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { show(current - 1); resetTimer(); });
      if (nextBtn) nextBtn.addEventListener('click', function() { show(current + 1); resetTimer(); });
      dots.forEach(function(dot) {
        dot.addEventListener('click', function() { show(parseInt(dot.dataset.index)); resetTimer(); });
      });

      startTimer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-live-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var el = document.getElementById('ft-live-date');
    if (!el) return;

    var friday = new Date();
    friday.setHours(12, 0, 0, 0);

    // 5 = Friday
    var daysUntilFriday = (5 - friday.getDay() + 7) % 7;

    friday.setDate(friday.getDate() + daysUntilFriday);

    var saturday = new Date(friday);
    saturday.setDate(friday.getDate() + 1);

    var options = {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    };

    el.textContent =
      friday.toLocaleDateString('en-US', options) +
      ' - ' +
      saturday.toLocaleDateString('en-US', options);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-menus-tabs"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.addEventListener('click', function(e) {
      var tab = e.target && e.target.closest && e.target.closest('.ft-menu-tab');
      if (!tab || !tab.dataset.tab) return;
      var id = tab.dataset.tab;
      document.querySelectorAll('.ft-menu-tab').forEach(function(t) {
        if (t.dataset.tab === id) {
          t.style.background = 'linear-gradient(135deg, #9c7a32, #c9a456)';
          t.style.color = '#0e0c09';
          t.style.borderColor = 'transparent';
          t.classList.add('ft-menu-tab--active');
        } else {
          t.style.background = '#1a1712';
          t.style.color = '#a09282';
          t.style.borderColor = '#2e2820';
          t.classList.remove('ft-menu-tab--active');
        }
      });
      // Toggle which panel is visible — CSS in ft-menus-content handles the rest
      document.querySelectorAll('.ft-menus-content').forEach(function(c) {
        c.setAttribute('data-active-panel', id);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-product-gift-card"]) return;
  try {
    
  (function() {
    var form = document.getElementById('ft-pgc-form');
    var amountDisplay = document.getElementById('ft-pgc-selected-amount');
    var variantBtns = document.querySelectorAll('.ft-pgc-variant-btn');

    // Update displayed amount + hidden input when variant button is clicked
    variantBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = btn.dataset.variantId;
        var variantPrice = btn.dataset.variantPrice;

        // Update hidden input
        var idInput = form ? form.querySelector('input[name="id"]') : null;
        if (idInput) idInput.value = variantId;

        // Update amount display
        if (amountDisplay) amountDisplay.textContent = variantPrice;

        // Update visual selection
        variantBtns.forEach(function(b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');

        // Update URL without reload
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ft-society-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var form = document.getElementById('ft-society-form');
    var success = document.getElementById('ft-society-success');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        form.style.display = 'none';
        if (success) success.style.display = 'block';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var nav = document.getElementById('ft-nav');
    var toggle = document.getElementById('ft-nav-toggle');
    var mobileMenu = document.getElementById('ft-mobile-menu');
    var iconOpen = document.getElementById('ft-nav-icon-open');
    var iconClose = document.getElementById('ft-nav-icon-close');
    var open = false;

    window.addEventListener('scroll', function() {
      if (window.scrollY > 40) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    });

    toggle.addEventListener('click', function() {
      open = !open;
      mobileMenu.style.display = open ? 'flex' : 'none';
      iconOpen.style.display = open ? 'none' : 'block';
      iconClose.style.display = open ? 'block' : 'none';
      document.body.style.overflow = open ? 'hidden' : '';
    });

    mobileMenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        open = false;
        mobileMenu.style.display = 'none';
        iconOpen.style.display = 'block';
        iconClose.style.display = 'none';
        document.body.style.overflow = '';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
